import React, { useEffect } from "react";
import {
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
// Styles
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import { Box, Button } from "@mui/material";
import PageContainer from "../../components/PageContainer/PageContainer";
// Assets
import { IconoMensajeErrorItal, MercadoPagoImg } from "assets";
// Service
import ClientService from "services/clientService";

import { saveSessionPasoPago } from "services/sessionStorageService";
import { URLs, getURLDespedida } from "../../utils/redirectStep";
import { getSessionPasoPago } from "services/sessionStorageService";
const baseUrlCanonical = window.baseUrlCanonical;

function CostoDeActivacionError() {
  //Inicializaciones base
  const clientService = new ClientService();
  const classes = useStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [modal, setModal] = React.useState({
    open: false,
    title: "",
    message: "",
    content: null,
  });

  // Inicializaciones particulares
  const {
    transactionId,
    document,
    idLead,
    pagoAnticipado,
    tipoTarjeta,
  } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const utmClient = searchParams.get("utm_source");
  const urlDespedida = getURLDespedida(utmClient);
  const handleModalCloseClick = () => {
    setModal({ ...modal, open: false });
    navigate(URLs.home);
  };

  const buildNavigateUrl = (path) => {
    const params = new URLSearchParams(searchParams);
    return `${path}${params ? "?" + params.toString() : ""}`;
  };

  // para redirigir
  useEffect(() => {
    const checkAndRedirect = async () => {
      const pasoPago = getSessionPasoPago();
      console.log(pasoPago);
      if (pasoPago === "mercadoPago") {
        openModalErrorPago(); //
      } else if (pasoPago === "redDePago") {
        const response = await clientService.evaluateDocument(document);
        openModalPagoPendiente(response.message);
      } else {
        navigate(URLs.home);
      }
    };
    checkAndRedirect();
  }, []);

  const openModalErrorPago = async () => {
    setModal({
      open: true,
      img: IconoMensajeErrorItal,
      showX: false,
      content: (
        <Box className={classes.modalContentDynamic}>
          <p style={{ fontSize: "15px", textAlign: "center", fontWeight: 500 }}>
            Tu pago no pudo ser procesado,
            <br />
            <span style={{ color: "#04808F", fontWeight: 600 }}>
              volvé a intentar o aboná en redes de cobranza.
            </span>
          </p>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginTop: "1rem",
            }}
          >
            <div className={classes.divBtn}>
              <Button
                className={`${classes.btnFull} ${classes.btnAzul}`}
                onClick={() => handleMercadoPagoClick()}
                variant="text"
                sx={{
                  width: "200px",
                  marginBottom: "0.3rem",
                }}
              >
                {"PAGO ONLINE"}
                <img
                  src={MercadoPagoImg}
                  alt="Home Mobile"
                  style={{
                    maxWidth: "50px",
                    maxHeight: "100%",
                    objectFit: "contain",
                    marginLeft: "0.5rem",
                  }}
                />
              </Button>
            </div>
            <div className={classes.divBtn}>
              <Button
                className={`${classes.btnFull} ${classes.btnAzul}`}
                onClick={() => handleRedDePagosClick()}
                variant="text"
                sx={{
                  width: "200px",
                  marginTop: "10px",
                }}
              >
                {"REDES DE COBRANZA"}
              </Button>
            </div>
          </Box>
        </Box>
      ),
    });
  };

  const handleRedDePagosClick = async (monto) => {
    setLoading(true);
    try {
      const transaction = {
        idLead: idLead,
        transactionId: transactionId,
        document: document,
      };
      console.log(transaction);
      const formData = {
        idMetodoPago: 2,
      };
      await clientService.confirmPaymentMethod(formData, transaction);
      saveSessionPasoPago("redDePago");
      navigate(buildNavigateUrl(urlDespedida), {
        state: { transaction: { tipoTarjeta: "plata-" + monto } },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleMercadoPagoClick = async () => {
    setLoading(true);
    const formData = {
      success: buildNavigateUrl(baseUrlCanonical + urlDespedida),
      failure: buildNavigateUrl(
        baseUrlCanonical +
          URLs.error +
          "/" +
          transactionId +
          "/" +
          document +
          "/" +
          idLead +
          "/" +
          pagoAnticipado
      ),
      pending: buildNavigateUrl(baseUrlCanonical + URLs.pendiente),
    };
    try {
      const transaction = {
        idLead: idLead,
        transactionId: transactionId,
        document: document,
      };
      const response = await clientService.mercadoPagoPreference(
        formData,
        transaction
      );
      if (response && response.data && response.data.urlLinkPago) {
        window.location.href = response.data.urlLinkPago;
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const openModalPagoPendiente = (responseMessage) => {
    const message = responseMessage;
    setModal({
      open: true,
      showX: true,
      message: message,
    });
  };

  return (
    <PageContainer
      loading={loading}
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.error}
      noImage={true}
    ></PageContainer>
  );
}

export default CostoDeActivacionError;
